"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('nine-points-connected', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M12 24C12 26.2091 10.2091 28 8 28C5.79086 28 4 26.2091 4 24C4 21.7909 5.79086 20 8 20C9.10457 20 10.1046 20.4477 10.8284 21.1716C11.5523 21.8954 12 22.8954 12 24Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M12 40C12 42.2091 10.2091 44 8 44C5.79086 44 4 42.2091 4 40C4 37.7909 5.79086 36 8 36C9.10457 36 10.1046 36.4477 10.8284 37.1716C11.5523 37.8954 12 38.8954 12 40Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M28 8C28 10.2091 26.2091 12 24 12C22.8954 12 21.8954 11.5523 21.1716 10.8284C20.4477 10.1046 20 9.10457 20 8C20 5.79086 21.7909 4 24 4C26.2091 4 28 5.79086 28 8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M28 24C28 26.2091 26.2091 28 24 28C22.8954 28 21.8954 27.5523 21.1716 26.8284C20.4477 26.1046 20 25.1046 20 24C20 21.7909 21.7909 20 24 20C25.1046 20 26.1046 20.4477 26.8284 21.1716C27.5523 21.8954 28 22.8954 28 24Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M28 40C28 42.2091 26.2091 44 24 44C21.7909 44 20 42.2091 20 40C20 37.7909 21.7909 36 24 36C25.1046 36 26.1046 36.4477 26.8284 37.1716C27.5523 37.8954 28 38.8954 28 40Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 8C44 10.2091 42.2091 12 40 12C38.8954 12 37.8954 11.5523 37.1716 10.8284C36.4477 10.1046 36 9.10457 36 8C36 5.79086 37.7909 4 40 4C42.2091 4 44 5.79086 44 8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 24C44 26.2091 42.2091 28 40 28C38.8954 28 37.8954 27.5523 37.1716 26.8284C36.4477 26.1046 36 25.1046 36 24C36 21.7909 37.7909 20 40 20C42.2091 20 44 21.7909 44 24Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 40C44 42.2091 42.2091 44 40 44C37.7909 44 36 42.2091 36 40C36 37.7909 37.7909 36 40 36C42.2091 36 44 37.7909 44 40Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M26.8284 21.1716C26.1046 20.4477 25.1046 20 24 20C21.7909 20 20 21.7909 20 24C20 25.1046 20.4477 26.1046 21.1716 26.8284M26.8284 21.1716C27.5523 21.8954 28 22.8954 28 24C28 26.2091 26.2091 28 24 28C22.8954 28 21.8954 27.5523 21.1716 26.8284M26.8284 21.1716L37.1716 10.8284M21.1716 26.8284L10.8284 37.1716M10.8284 21.1716C10.1046 20.4477 9.10457 20 8 20C5.79086 20 4 21.7909 4 24C4 26.2091 5.79086 28 8 28C10.2091 28 12 26.2091 12 24C12 22.8954 11.5523 21.8954 10.8284 21.1716ZM10.8284 21.1716L21.1716 10.8284M21.1716 10.8284C21.8954 11.5523 22.8954 12 24 12C26.2091 12 28 10.2091 28 8C28 5.79086 26.2091 4 24 4C21.7909 4 20 5.79086 20 8C20 9.10457 20.4477 10.1046 21.1716 10.8284ZM10.8284 37.1716C10.1046 36.4477 9.10457 36 8 36C5.79086 36 4 37.7909 4 40C4 42.2091 5.79086 44 8 44C10.2091 44 12 42.2091 12 40C12 38.8954 11.5523 37.8954 10.8284 37.1716ZM26.8284 37.1716C26.1046 36.4477 25.1046 36 24 36C21.7909 36 20 37.7909 20 40C20 42.2091 21.7909 44 24 44C26.2091 44 28 42.2091 28 40C28 38.8954 27.5523 37.8954 26.8284 37.1716ZM26.8284 37.1716L37.1716 26.8284M37.1716 26.8284C37.8954 27.5523 38.8954 28 40 28C42.2091 28 44 26.2091 44 24C44 21.7909 42.2091 20 40 20C37.7909 20 36 21.7909 36 24C36 25.1046 36.4477 26.1046 37.1716 26.8284ZM37.1716 10.8284C37.8954 11.5523 38.8954 12 40 12C42.2091 12 44 10.2091 44 8C44 5.79086 42.2091 4 40 4C37.7909 4 36 5.79086 36 8C36 9.10457 36.4477 10.1046 37.1716 10.8284ZM12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8ZM44 40C44 42.2091 42.2091 44 40 44C37.7909 44 36 42.2091 36 40C36 37.7909 37.7909 36 40 36C42.2091 36 44 37.7909 44 40Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;